import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.4_@parcel+watcher@2.5.1_@types+node@22.15.21_@upstash+redis@1.34.9_@vercel+blob@1.0_5wlfb5gpmnln2tkjyrubehpdsq/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/vercel/path0/node_modules/.pnpm/@nuxt+ui-pro@1.8.0_axios@1.9.0_jwt-decode@4.0.0_magicast@0.3.5_ts-node@10.9.1_@types+node@22._vj7d25ytzruylaqz2t722xymqa/node_modules/@nuxt/ui-pro/modules/pro/runtime/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}